import { DateTime } from "luxon";

export const getDateTimeDefault = (shorthand = "last_30_minutes") => {
  let validatedShorthand = Object.keys(shorthandOperators).includes(shorthand)
    ? shorthand
    : "last_30_minutes";

  return {
    ...shorthandOperators[validatedShorthand]("yyyy-MM-dd", "HH:mm"),
    timeRange: validatedShorthand,
  };
};

export const appliedDateFormat = "yyyy-MM-dd";
export const appliedTimeFormat = "HH:mm";

export const timeRanges = [
  { label: "Last 30 Minutes", value: "last_30_minutes" },
  { label: "Last Hour", value: "last_hour" },
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This Week", value: "this_week" },
  { label: "Last Week", value: "last_week" },
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Custom", value: "custom" },
];

export const shorthandOperators = {
  last_30_minutes: (dateFormat, timeFormat) => {
    const origin = DateTime.now();
    const startValue = origin.minus({ minute: 30 });

    return {
      endDate: origin.toFormat(dateFormat),
      endTime: origin.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  last_hour: (dateFormat, timeFormat) => {
    const origin = DateTime.now();
    const startValue = origin.minus({ hour: 1 });

    return {
      endDate: origin.toFormat(dateFormat),
      endTime: origin.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  last_week: (dateFormat, timeFormat) => {
    const origin = DateTime.now().minus({ week: 1 });
    const endValue = origin.endOf("week");
    const startValue = origin.startOf("week");

    return {
      endDate: endValue.toFormat(dateFormat),
      endTime: endValue.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  last_month: (dateFormat, timeFormat) => {
    const origin = DateTime.now().minus({ month: 1 });
    const endValue = origin.endOf("month");
    const startValue = origin.startOf("month");

    return {
      endDate: endValue.toFormat(dateFormat),
      endTime: endValue.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  this_week: (dateFormat, timeFormat) => {
    const origin = DateTime.now();
    const startValue = origin.startOf("week");

    return {
      endDate: origin.toFormat(dateFormat),
      endTime: origin.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  this_month: (dateFormat, timeFormat) => {
    const origin = DateTime.now();
    const startValue = origin.startOf("month");

    return {
      endDate: origin.toFormat(dateFormat),
      endTime: origin.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  today: (dateFormat, timeFormat) => {
    const origin = DateTime.now();
    const startValue = origin.startOf("day");

    return {
      endDate: origin.toFormat(dateFormat),
      endTime: origin.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
  yesterday: (dateFormat, timeFormat) => {
    const origin = DateTime.now().minus({ day: 1 });
    const endValue = origin.endOf("day");
    const startValue = origin.startOf("day");

    return {
      endDate: endValue.toFormat(dateFormat),
      endTime: endValue.toFormat(timeFormat),
      startDate: startValue.toFormat(dateFormat),
      startTime: startValue.toFormat(timeFormat),
    };
  },
};
